import { useLocation } from "wouter";
import { Button } from "./ui/button";

export const NotFound = () => {
  const [, setLocation] = useLocation();
  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">
            404
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            Something's missing.
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            Sorry, we can't find that page. Let's get back to working on those
            commissions.{" "}
          </p>
          <Button onClick={() => setLocation(import.meta.env.VITE_SITE_URL)}>
            Back to Dashboard
          </Button>
        </div>
      </div>
    </section>
  );
};
